// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2LAx8","form":"styles_form__Tn1yL"};